import { NavigationItem } from '../context/current-context.model';
import { WayfindingJob } from './wayfinding.models';
import { camelTokens, ComposableJob, slugTokens, uniqueNeedles } from './wayfinding-compose';

export function buildLiveWayfindingJobs(
  navItems: NavigationItem[],
  curated: WayfindingJob[],
  translate: (key: string) => string
): ComposableJob[] {
  const byRoute = new Map<string, ComposableJob>();

  for (const item of navItems) {
    const route = normalizeRoute(item.route);
    if (!route || route === '/dashboard' || route.includes(':')) {
      continue;
    }

    const titleKey = item.label;
    const copies = featureCopy(item.label, translate);
    byRoute.set(route, {
      id: `nav:${item.key}`,
      route,
      titleKey,
      descriptionKey: 'wayfinding.liveStep.why',
      needles: uniqueNeedles([
        translate(titleKey),
        ...copies,
        ...slugTokens(route),
        ...camelTokens(item.key)
      ])
    });
  }

  for (const job of curated) {
    const route = normalizeRoute(job.route);
    const existing = byRoute.get(route);
    byRoute.set(route, {
      id: job.id,
      route,
      titleKey: job.titleKey,
      descriptionKey: job.descriptionKey,
      needles: uniqueNeedles([
        ...(existing?.needles ?? []),
        translate(job.titleKey),
        translate(job.descriptionKey),
        ...job.synonyms,
        ...slugTokens(route)
      ])
    });
  }

  return [...byRoute.values()];
}

function featureCopy(labelKey: string, translate: (key: string) => string): string[] {
  const stem = labelKey.startsWith('nav.') ? labelKey.slice(4) : labelKey;
  return [
    `${stem}.title`,
    `${stem}.description`,
    `${stem}.help.title`,
    `${stem}.studio.title`,
    `${stem}.reviewList.title`
  ]
    .map(key => {
      const value = translate(key);
      return value && value !== key ? value : '';
    })
    .filter(Boolean);
}

function normalizeRoute(route: string): string {
  if (!route) {
    return '';
  }

  return route.startsWith('/') ? route : `/${route}`;
}
